var _g, _g2, _g3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_1_",
    "data-name": "search (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.304,
    height: 33.304,
    viewBox: "0 0 33.304 33.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55228",
    "data-name": "Group 55228",
    transform: "translate(5.007 7.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55227",
    "data-name": "Group 55227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82787",
    "data-name": "Path 82787",
    d: "M81.166,111.336a1.23,1.23,0,0,0-1.74,0,8.409,8.409,0,0,0-2.405,6.816,1.231,1.231,0,0,0,1.223,1.108c.041,0,.082,0,.123-.006a1.231,1.231,0,0,0,1.1-1.347,5.957,5.957,0,0,1,1.7-4.832A1.23,1.23,0,0,0,81.166,111.336Z",
    transform: "translate(-76.978 -110.976)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55230",
    "data-name": "Group 55230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55229",
    "data-name": "Group 55229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82788",
    "data-name": "Path 82788",
    d: "M14.068,0A14.068,14.068,0,1,0,28.136,14.068,14.084,14.084,0,0,0,14.068,0Zm0,25.675A11.607,11.607,0,1,1,25.675,14.068,11.62,11.62,0,0,1,14.068,25.675Z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55232",
    "data-name": "Group 55232",
    transform: "translate(21.902 21.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55231",
    "data-name": "Group 55231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82789",
    "data-name": "Path 82789",
    d: "M347.75,346.011l-8.941-8.941a1.23,1.23,0,0,0-1.74,1.74l8.941,8.941a1.23,1.23,0,1,0,1.74-1.74Z",
    transform: "translate(-336.708 -336.71)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1ea47af96ab40cd19f429f645f86d2b3.svg";
export { ForwardRef as ReactComponent };